import {IsInt, IsNotEmpty, IsOptional, Validate} from "class-validator";
import {CustomIdDTO} from "../common/id-validator.dto";

export class CreateBoxDTO {

    @IsNotEmpty()
    identifier!: string;

    @IsNotEmpty()
    hardwareVersion!: string;

    @IsNotEmpty()
    softwareVersion!: string;

    @IsOptional()
    @IsInt()
    sim?: number;

    @IsNotEmpty()
    @IsInt()
    boxLocation!: number


    @IsOptional()
    @Validate(CustomIdDTO, { each: true })
    boxInterfaces : number[];


}

